import React from "react";
import { motion } from "framer-motion";
import company1 from "../../../images/companies/Capital_One-Logo.wine.png"
import company2 from "../../../images/companies/Goldman_Sachs-Logo.wine.png"
import company3 from "../../../images/companies/Google-Logo.wine.png"
import company4 from "../../../images/companies/MTI logo 1.png"
import company5 from "../../../images/companies/Mastercard-Logo.wine.png"
import company6 from "../../../images/companies/Teal_Sputnik 1.png"
import company7 from "../../../images/companies/Visible Hands_idOpe1T636_0.png"
import company8 from "../../../images/companies/idIc8jAkDQ_logos 1.png"

const SectionFive = () => {
  const logoAnimation = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.6, ease: "easeOut" },
    }),
  };

  const logos = [
    {
      src: company1,
      alt: "Capital One",
    },
    {
      src: company2,
      alt: "Co-creation HUB",
    },
    {
      src:company3 ,
      alt: "Google",
    },
    {
      src:company4 ,
      alt: "Visible Hands",
    },
    {
      src:company5 ,
      alt: "Teal Sputnik",
    },
    {
      src:company6 ,
      alt: "Mastercard",
    },
    {
      src: company7,
      alt: "MTI",
    },
    {
      src: company8,
      alt: "Goldman Sachs",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: true }}
      className="w-full bg-[#f4f8f7] py-16"
    >
      <div className="max-w-[1141px] mx-auto flex flex-col items-center gap-6">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="max-w-[802px] flex flex-col items-center gap-2"
        >
          <h3 className="text-[#ef8702] font-extrabold text-base">
            OUR INDUSTRY BACKERS
          </h3>
          <div className="flex flex-col items-center gap-4">
            <h1 className="text-3xl font-black text-center">
              Supported By Leading Companies
            </h1>
            <p className="text-base text-center max-w-[800px]">
              Our AI-powered translation and speech tools are backed by
              prominent companies who believe in our mission to enhance
              multilingual communication across the continent.
            </p>
          </div>
        </motion.div>

        <div className="flex flex-col gap-6 w-full">
          {/* Logos Container */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 place-items-center">
            {logos.map((logo, index) => (
              <motion.img
                key={index}
                src={logo.src}
                alt={logo.alt}
                className="w-[120px] md:w-[200px] object-contain hover:opacity-80 transition-opacity"
                variants={logoAnimation}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={index}
              />
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SectionFive;
